import React, { useContext } from 'react'

import type {
  IBranchesState,
  IBranchSingleProps,
  IBranchSinglePropsPartial,
} from './model'
import type { IParam } from 'libs/apis'

const branches: [] = []
const page = 1
const searchParams = {}
const updateBranches = (): void => void 0

export const initialState: IBranchesState = {
  branches,
  page,
  searchParams,
  updateBranches,
}

export const BranchContext = React.createContext(initialState)

export const useBranchContext = (): IBranchesState => {
  return useContext(BranchContext)
}

type Action = {
  type: 'UPDATE'
  payload: {
    newBranch: IBranchSingleProps[]
    page: number
    searchParams: IParam & IBranchSinglePropsPartial
  }
}

export const reducer = (
  state: IBranchesState,
  action: Action,
): IBranchesState => {
  const { type, payload } = action

  switch (type) {
    case 'UPDATE':
      return {
        ...state,
        branches: payload.newBranch,
        page: payload.page,
        searchParams: payload.searchParams,
      }

    default:
      throw new Error(`Unknown company ${type} type`)
  }
}
